// extracted by mini-css-extract-plugin
export var header = "PLPBanner-mps-module--header--66ec9";
export var root = "PLPBanner-mps-module--root--c5d13";